import { Pipe, PipeTransform } from '@angular/core';
import { declarationAppUrls, notificationAppUrls } from '../app.routes';

@Pipe({
  name: 'applicationInfoActionName',
  standalone: true
})
export class ApplicationInfoActionNamePipe implements PipeTransform {

  transform(value?: string | null): string {
    switch (true) {
      case declarationAppUrls.includes(value || ''): {
        return 'Przejdź do złożenia deklaracji';
      }
      case notificationAppUrls.includes(value || ''): {
        return 'Przejdź do złożenia zgłoszenia';
      }
      default: {
        return 'Przejdź do złożenia wniosku';
      }
    }
  }

}
